import {IIcon} from '../common/icon';
import {IFormElement} from './base/formElementBase';
import {ISlideChangeable} from './base/slideChangeable';
import {ELEMENT} from './base/ElementTypes';
import {IFontElement} from './base/fontElement';

export type ButtonType = 'button' | 'submit';
export const BUTTON_TYPE: ButtonType[] = ['button', 'submit'];
export interface IElementButton extends IFormElement, ISlideChangeable, IFontElement {
    type: ELEMENT.BUTTON;
    text: string;
    color: string;
    icon?: IIcon;
    htmlType: ButtonType;
}
